





































import { Component, Vue, Prop } from "vue-property-decorator";
import MainHeader from "../../../main/components/main-header/main-header.vue";
import MainLeft from "../../../sjzx/modules/zbsjk/components//nav-left.vue";
import { GetCenter, GetHospitals } from "@/request/sjzx";
import Zhiweibing from "./center-transfer/zhiweibing/zhiweibing.vue";
import Linchuang from "./center-transfer/linchuang/linchuang.vue";
import Yingxiang from "./center-transfer/yingxiang/yingxiang.vue";
@Component({
  components: {
    MainHeader,
    MainLeft,
    Zhiweibing,
    Linchuang,
    Yingxiang,
  },
})
export default class Dictionary extends Vue {
  private currentPart = "";
  private data: any = {};
  private search: any = "";
  private cCenter: any = "";
  private centers: any[] = [];
  private loaded: boolean = false;
  private get user() {
    return this.$store.state.user;
  }
  /**
   * @description 展示模块改变
   */
  private changeCenter(center) {
    this.loaded = false;
    this.$router.push({
      path: "/main/sjzx/shujukanban",
      query: {
        project_id: center.project_id,
      },
    });
    this.$nextTick().then(() => {
      this.cCenter = center;
      this.loaded = true;
    });
  }
  /**
   * @description 获取全部中心
   */
  private fetchCenters() {
    return new Promise((resolve, reject) => {
      GetCenter(this)
        .then((data: any) => {
          this.centers = data;
          if (this.centers.length > 0) {
            if (this.$route.query.project_id) {
              this.centers.forEach((center: any) => {
                if (center.project_id === this.$route.query.project_id) {
                  this.cCenter = center;
                }
              });
            } else {
              this.cCenter = this.centers[0];
            }
            this.loaded = true;
          }
          resolve();
        })
        .catch(() => {
          reject();
        });
    });
  }
  /**
   * @description 初始化
   */
  private mounted() {
    this.fetchCenters();
  }
}
